import React from 'react';
import Icon from '../../../components/AppIcon';

const EmailFilterPanel = ({ filters, onFilterChange }) => {
  const handleInputChange = (field, value) => {
    onFilterChange?.({ [field]: value });
  };

  const handleClearFilters = () => {
    onFilterChange?.({
      deliveryStatus: '',
      dateFrom: '',
      dateTo: '',
      recipientEmail: '',
      searchTerm: ''
    });
  };

  return (
    <div className="bg-neutral-50 rounded-lg p-4 border border-neutral-200">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-neutral-900 flex items-center gap-2">
          <Icon name="Filter" size={18} />
          Filter Email Logs
        </h3>
        <button
          onClick={handleClearFilters}
          className="text-sm text-blue-600 hover:text-blue-700 font-medium"
        >
          Clear Filters
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div>
          <label className="block text-sm font-medium text-neutral-700 mb-1">
            Delivery Status
          </label>
          <select
            value={filters?.deliveryStatus || ''}
            onChange={(e) => handleInputChange('deliveryStatus', e?.target?.value)}
            className="w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">All Statuses</option>
            <option value="delivered">Delivered</option>
            <option value="sent">Sent</option>
            <option value="pending">Pending</option>
            <option value="failed">Failed</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-neutral-700 mb-1">
            Date From
          </label>
          <input
            type="date"
            value={filters?.dateFrom || ''}
            onChange={(e) => handleInputChange('dateFrom', e?.target?.value)}
            className="w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-neutral-700 mb-1">
            Date To
          </label>
          <input
            type="date"
            value={filters?.dateTo || ''}
            onChange={(e) => handleInputChange('dateTo', e?.target?.value)}
            className="w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-neutral-700 mb-1">
            Recipient Email
          </label>
          <input
            type="text"
            value={filters?.recipientEmail || ''}
            onChange={(e) => handleInputChange('recipientEmail', e?.target?.value)}
            placeholder="Search by email..."
            className="w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>
    </div>
  );
};

export default EmailFilterPanel;